export default "__VITE_ASSET__66d6bd7e__"